import React from "react";

export function CorePositivity() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path d="M30 1.5C14.262 1.5 1.5 14.262 1.5 30C1.5 45.738 14.262 58.5 30 58.5C45.738 58.5 58.5 45.738 58.5 30C58.5 14.262 45.738 1.5 30 1.5ZM19.824 19.824C22.068 19.824 23.892 21.642 23.892 23.892C23.892 26.142 22.068 27.966 19.824 27.966C17.574 27.966 15.75 26.142 15.75 23.892C15.75 21.642 17.574 19.824 19.824 19.824ZM30 46.818C22.836 46.818 16.902 41.604 15.75 34.764H44.25C43.1041 41.598 37.17 46.818 30 46.818ZM40.176 27.966C37.932 27.966 36.108 26.142 36.108 23.892C36.108 21.642 37.932 19.824 40.176 19.824C42.426 19.824 44.25 21.642 44.25 23.892C44.25 26.142 42.426 27.966 40.176 27.966Z" fill="#8245DC" />
    </svg>
  );
}
